import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { TranslationService } from '../translations';

type DashboardOptions = {
    pageDescription?: string;
    loading?: boolean;
};

@Component({
    selector: 'dashboard',
    host: {
        class: 'pi-dashboard',
        '[class.pi-dashboard--loading]': 'options.loading'
    },
    template: `
        <div class="pi-dashboard_backLink onlyShowIfIHaveChildren">
            <ng-content select="[dashboard-backLink]"></ng-content>
        </div>
        <div
            class="pi-dashboard_title onlyShowIfIHaveChildren"
            [hidden]="options.loading"
        >
            <ng-content select="[dashboard-title]"></ng-content>
        </div>
        <div class="pi-dashboard_subtitle onlyShowIfIHaveChildren">
            <ng-content select="[dashboardSubTitleContent]"></ng-content>
        </div>

        <div class="pi-dashboard_loading-indicator">
            <p>
                {{ TR.key('label.common-terms.loading') }}
                {{ options.pageDescription }}
            </p>
            <div class="spinner spinner--person"></div>
        </div>

        <div class="pi-dashboard_content">
            <ng-content select="[dashboard-body]"></ng-content>
        </div>
    `,
    standalone: false
})
export class DashboardComponent {
    @Input()
    options: DashboardOptions = {};
    @ViewChild('titleRef', { static: false })
    titleRef: ElementRef;
    @ViewChild('subtitleRef', { static: false })
    subtitleRef: ElementRef;

    constructor(public TR: TranslationService) {}
}
